export const CONTACT = {
  proprietor: { name: "Mohammad Rafiq Siddiqui", role: "Proprietor", phone: "9210638205" },
  sales: { name: "Mohammad Asif Siddiqui", role: "Sales & Marketing Manager", phone: "8376863221", whatsapp: "8796445811" },
  phones: ["9210638205", "8376863221", "7303374227"],
  email: "paraphrase3@gmail.com",
  whatsapp: "918796445811",
  address: "334, Street No. 9, New Lahore Colony, Shastri Nagar, Near Bismillah Masjid, Delhi – 110031, India",
  instagram: "https://www.instagram.com/alpasservovoltage/",
  mapQuery: "334 Street No. 9 New Lahore Colony Shastri Nagar Delhi 110031",
};

export const PRODUCTS = [
  {
    slug: "digital-servo-voltage-stabilizers",
    name: "Digital Servo Voltage Stabilizers",
    short: "Servo Voltage Stabilizers",
    tagline: "Precise voltage correction for reliable electrical performance.",
    range: "5 KVA – 1000 KVA",
    phase: "Single / Three Phase",
    cooling: "Air / Oil Cooled",
    image: "/assets/product-stabilizer-oil.jpeg",
    summary: "Fully automatic, micro-controlled servo stabilizers with 100% copper wound transformers for industrial and commercial loads.",
    description: [
      "ALPAS Digital Servo Voltage Stabilizers deliver precise, fully automatic voltage correction for industrial, commercial and specialized applications. Built around a micro-controlled digital display circuit and a brushless AC synchronous motor, they correct voltage fluctuation at 20V/sec while maintaining output at 400V ±1% (230V).",
      "Every stabilizer is 100% copper wound with copper wound main load transformers, housed in a powder coated cabinet and fitted with branded contactors — engineered for a service life measured in decades, not years.",
    ],
    specs: [
      ["Capacity Range", "5 KVA to 1000 KVA"],
      ["Configuration", "Single / Three Phase"],
      ["Cooling", "Air / Oil Cooled"],
      ["Type", "Balance / Unbalance Type"],
      ["Input Voltage Ranges", "300–470V, 340–470V, 250–470V models"],
      ["Output Voltage", "400V ±1% (230V)"],
      ["Rate of Correction", "20V/sec"],
      ["Operation", "Fully Automatic"],
      ["Winding", "100% Copper Wound"],
      ["Main Load Transformers", "Copper Wound"],
      ["Cabinet", "Powder Coated"],
      ["Efficiency", "98%"],
      ["Frequency", "50 Hz"],
      ["Adjustment", "Auto / Manual Adjustment System"],
      ["Ambient Temperature", "50°C"],
      ["Contactors", "Branded Contactors"],
    ],
    features: [
      "Fully automatic micro-controlled digital display circuit",
      "High-speed voltage correction",
      "Fine output voltage adjustment",
      "Brushless AC synchronous motor",
      "Front-panel mains and voltage-limit indication",
      "Plug-in control card for serviceability",
      "Under/over-voltage cut-off",
      "Overload cut-off",
      "Load current display",
      "Single-phasing preventer",
    ],
    applications: ["CNC Machines", "Hospitals", "Textile Mills", "Injection Moulding Machines", "Cold Storages", "Engineering Units"],
    seoTitle: "Digital Servo Voltage Stabilizer Manufacturer in Delhi | 5–1000 KVA | ALPAS",
    seoDescription: "ALPAS digital servo voltage stabilizers from 5 KVA to 1000 KVA — fully automatic, 100% copper wound, 98% efficiency. Manufactured in India by Paraphase Controls & Transformers. Request a quote.",
  },
  {
    slug: "isolation-transformers",
    name: "Isolation Transformers",
    short: "Isolation Transformers",
    tagline: "Reliable electrical isolation solutions for industrial and sensitive applications.",
    range: "10 KVA – 500 KVA",
    image: "/assets/product-stabilizer-single.jpeg",
    summary: "Dependable galvanic isolation for sensitive equipment and industrial installations, from 10 KVA to 500 KVA.",
    description: [
      "ALPAS Isolation Transformers provide dependable electrical isolation between supply and load, protecting sensitive equipment from disturbances carried on the power line and improving safety in industrial installations.",
      "Manufactured in-house from 10 KVA to 500 KVA, each unit is built to order with the same quality-first approach that has defined Paraphase Controls & Transformers for over 25 years.",
    ],
    specs: [["Capacity Range", "10 KVA to 500 KVA"]],
    features: [
      "Galvanic isolation between supply and load",
      "Protects sensitive and critical equipment",
      "Built for continuous industrial duty",
      "In-house manufactured and tested",
    ],
    applications: ["Medical Equipment", "Hospitals", "CNC Machines", "Engineering Units", "Pharmaceutical Units", "X-Ray Machines"],
    seoTitle: "Isolation Transformer Manufacturer India | 10–500 KVA | ALPAS",
    seoDescription: "ALPAS isolation transformers from 10 KVA to 500 KVA for industrial and sensitive applications. Manufactured in Delhi, India. Request a quote from Paraphase Controls & Transformers.",
  },
  {
    slug: "ultra-isolation-transformers",
    name: "Ultra Isolation Transformers",
    short: "Ultra Isolation Transformers",
    tagline: "Superior isolation for noise-sensitive and critical equipment.",
    range: "Built to application requirement",
    image: "/assets/product-stabilizer-single.jpeg",
    summary: "Enhanced isolation transformers for critical loads where power-line noise and disturbances cannot be tolerated.",
    description: [
      "ALPAS Ultra Isolation Transformers are designed for installations where ordinary isolation is not enough — shielding sensitive electronics, instrumentation and critical loads from power-line disturbances.",
      "Every unit is engineered to the application's requirement and manufactured in-house with full quality backing and after-sales support.",
    ],
    specs: [["Configuration", "Engineered to application requirement"]],
    features: [
      "Enhanced isolation for noise-sensitive loads",
      "Shields critical equipment from line disturbances",
      "Application-specific engineering",
      "In-house manufactured and tested",
    ],
    applications: ["Medical Equipment", "X-Ray Machines", "Pharmaceutical Units", "Hospitals", "Engineering Units", "CNC Machines"],
    seoTitle: "Ultra Isolation Transformer Manufacturer India | ALPAS",
    seoDescription: "ALPAS ultra isolation transformers for noise-sensitive and critical equipment — engineered and manufactured in India by Paraphase Controls & Transformers. Request a quote.",
  },
  {
    slug: "furnace-ultra-isolation-transformers",
    name: "Furnace Ultra Isolation Transformers",
    short: "Furnace Ultra Isolation Transformers",
    tagline: "Heavy-duty isolation engineered for furnace and demanding thermal applications.",
    range: "Built to furnace duty requirement",
    image: "/assets/product-stabilizer-oil.jpeg",
    summary: "Rugged ultra isolation transformers purpose-built for the harsh electrical environment of furnaces and melting shops.",
    description: [
      "Furnace duty places extraordinary stress on electrical equipment. ALPAS Furnace Ultra Isolation Transformers are purpose-built for these demanding environments, combining heavy-duty construction with enhanced isolation.",
      "Trusted across rolling mills, tube mills and foundry applications, each transformer is manufactured in-house and backed by our after-sales service commitment.",
    ],
    specs: [["Configuration", "Engineered to furnace duty requirement"]],
    features: [
      "Purpose-built for furnace and thermal applications",
      "Heavy-duty construction for harsh environments",
      "Enhanced isolation for demanding loads",
      "Backed by after-sales service support",
    ],
    applications: ["Rolling Mills", "Tube Mills", "Engineering Units", "Rubber Industries", "Cement Plants", "Flour Mills"],
    seoTitle: "Furnace Ultra Isolation Transformer Manufacturer | ALPAS India",
    seoDescription: "ALPAS furnace ultra isolation transformers built for heavy-duty thermal and furnace applications. Manufactured in India by Paraphase Controls & Transformers. Request a quote.",
  },
  {
    slug: "variable-auto-transformers-variacs",
    name: "Variable Auto Transformers (Variacs / Dimmers)",
    short: "Variacs / Dimmers",
    tagline: "Smooth, stepless voltage control from zero to maximum.",
    range: "10 Amp – 3000 Amp",
    image: "/assets/product-toroidal-rack.jpeg",
    summary: "Precision variable auto transformers for testing, control and dimming applications — 10 Amp to 3000 Amp.",
    description: [
      "ALPAS Variable Auto Transformers (Variacs / Dimmers) provide smooth, stepless output voltage control for testing benches, laboratories, motor control, heating and dimming applications.",
      "The range spans 10 Amp to 3000 Amp, alongside Single Phase Air Cooled Double Wound Variacs from 5 KVA to 35 KVA — all wound and assembled in-house.",
    ],
    specs: [
      ["Current Range", "10 Amp to 3000 Amp"],
      ["Single Phase Air Cooled Double Wound Variac", "5 KVA to 35 KVA"],
    ],
    features: [
      "Smooth, stepless voltage variation",
      "Toroidal wound construction",
      "Suitable for test benches and laboratories",
      "In-house wound and assembled",
    ],
    applications: ["Engineering Units", "Textile Mills", "Pharmaceutical Units", "Food Processing Units", "Paper Mills", "Lathe Machines"],
    seoTitle: "Variac Manufacturer India | Variable Auto Transformers 10A–3000A | ALPAS",
    seoDescription: "ALPAS variable auto transformers (variacs / dimmers) from 10 Amp to 3000 Amp, plus single phase air cooled double wound variacs 5–35 KVA. Made in India. Request a quote.",
  },
  {
    slug: "toroidal-transformers",
    name: "Toroidal Transformers",
    short: "Toroidal Transformers",
    tagline: "Compact, efficient toroidal winding for servo and precision applications.",
    range: "2 KVA – 50 KVA (Servo)",
    image: "/assets/product-toroidal-rack.jpeg",
    summary: "Toroidal transformers for servo applications from 2 KVA to 50 KVA — the heart of every ALPAS stabilizer.",
    description: [
      "Toroidal transformers are the beating heart of every servo stabilizer. ALPAS winds its own toroidal transformers in-house for servo applications from 2 KVA to 50 KVA, ensuring complete control over quality.",
      "Because we wind our own toroids, we can also build them to your specific requirement — with the consistency that only in-house manufacturing delivers.",
    ],
    specs: [["Toroidal Transformers for Servo", "2 KVA to 50 KVA"]],
    features: [
      "In-house toroidal winding",
      "Compact and efficient construction",
      "Purpose-built for servo applications",
      "Custom winding on requirement",
    ],
    applications: ["Engineering Units", "CNC Machines", "Medical Equipment", "Textile Mills", "Pharmaceutical Units", "Offset Machines"],
    seoTitle: "Toroidal Transformer Manufacturer India | 2–50 KVA Servo | ALPAS",
    seoDescription: "ALPAS toroidal transformers for servo applications from 2 KVA to 50 KVA, wound in-house by Paraphase Controls & Transformers, India. Request a quote.",
  },
  {
    slug: "custom-built-transformers",
    name: "Custom-Built Transformers",
    short: "Custom Transformers",
    tagline: "Application-specific transformers, engineered and wound to your exact requirement.",
    range: "Engineered to specification",
    image: "/assets/product-stabilizer-hero.jpeg",
    summary: "When a catalogue product won't do, we design and manufacture transformers to your exact electrical and mechanical requirement.",
    description: [
      "Not every application fits a standard product. Paraphase Controls & Transformers has spent over 25 years building custom transformers for application-specific requirements across industries.",
      "Share your electrical and mechanical requirements and our team will engineer, wind, assemble and test a transformer built exactly for your application — with full after-sales service backing.",
    ],
    specs: [["Configuration", "Engineered and manufactured to your specification"]],
    features: [
      "Application-specific design and engineering",
      "In-house winding, assembly and testing",
      "Built for your exact electrical requirement",
      "Full after-sales service backing",
    ],
    applications: ["Engineering Units", "Rolling Mills", "Cement Plants", "Textile Mills", "Paper Mills", "Food Processing Units"],
    seoTitle: "Custom-Built Transformer Manufacturer India | ALPAS",
    seoDescription: "Application-specific custom-built transformers engineered and manufactured in India by Paraphase Controls & Transformers. Share your requirement and request a quote.",
  },
  {
    slug: "servo-type-dc-drives",
    name: "Servo Type DC Drives",
    short: "Servo DC Drives",
    tagline: "Dependable DC drive solutions for industrial machinery.",
    range: "Built to application requirement",
    image: "/assets/product-stabilizer-single.jpeg",
    summary: "Servo type DC drives manufactured and serviced for industrial machinery applications.",
    description: [
      "ALPAS Servo Type DC Drives extend our power-control expertise to industrial drive applications, manufactured and serviced with the same quality-first, value-for-money principle that defines our brand.",
      "Contact our team with your machine and application details to discuss a drive solution matched to your requirement.",
    ],
    specs: [["Configuration", "Engineered to application requirement"]],
    features: [
      "Industrial-grade construction",
      "Manufactured and serviced in-house",
      "Application-matched solutions",
      "After-sales service support",
    ],
    applications: ["Lathe Machines", "Injection Moulding Machines", "Engineering Units", "Textile Mills", "Rolling Mills", "Rubber Industries"],
    seoTitle: "Servo Type DC Drives Manufacturer India | ALPAS",
    seoDescription: "ALPAS servo type DC drives for industrial machinery, manufactured and serviced in India by Paraphase Controls & Transformers. Request a quote.",
  },
  {
    slug: "power-factor-solutions",
    name: "Power Factor Solutions",
    short: "Power Factor Solutions",
    tagline: "Improve efficiency and reduce power costs with engineered power factor correction.",
    range: "Engineered to installation requirement",
    image: "/assets/product-stabilizer-hero.jpeg",
    summary: "Power factor correction solutions engineered for industrial and commercial electrical installations.",
    description: [
      "Poor power factor inflates electricity bills and stresses electrical infrastructure. ALPAS Power Factor Solutions are engineered for industrial and commercial installations to improve efficiency and reliability.",
      "Share your installation details and our team will recommend a solution matched to your load profile — backed by our manufacturing and service network.",
    ],
    specs: [["Configuration", "Engineered to installation requirement"]],
    features: [
      "Engineered for industrial installations",
      "Improves electrical efficiency",
      "Application-matched recommendations",
      "Manufacturing and service backing",
    ],
    applications: ["Cement Plants", "High Rise Buildings", "Cold Storages", "Textile Mills", "Paper Mills", "Flour Mills"],
    seoTitle: "Power Factor Correction Solutions India | ALPAS",
    seoDescription: "ALPAS power factor solutions for industrial and commercial installations — engineered by Paraphase Controls & Transformers, India. Request a quote.",
  },
];

export const INDUSTRIES = [
  "Cement Plants", "High Rise Buildings", "Cold Storages", "Tea Estates", "Tube Mills",
  "Flour Mills", "Rolling Mills", "Textile Mills", "Paper Mills", "Clubs & Hotels",
  "Hospitals", "Engineering Units", "Rubber Industries", "Food Processing Units",
  "Pharmaceutical Units", "Medical Equipment", "Footwear & Leather Units", "CNC Machines",
  "Lathe Machines", "Injection Moulding Machines", "X-Ray Machines", "Label Machines", "Offset Machines",
];

export const CLIENTS = [
  "Ministry of Home Affairs",
  "MES",
  "Govt. of India Press, New Delhi",
  "Ranbir Govt. Press, Jammu",
  "Kurukshetra University",
  "Rajasthan University, Jaipur",
  "Donbosco Institute",
  "All India Teachers Federation, New Delhi",
  "Ranbaxy",
  "Kuwait Airways",
  "Union Bank of India",
  "Punjab National Bank",
  "Northern Railway",
  "Textiles Machinery Industry",
];

export const telLink = (num) => `tel:+91${num}`;
export const waLink = (text = "Hello ALPAS, I would like to request a quote.") =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(text)}`;
